// Typed trusted-devices API. Mirrors the auth/admin api pattern: real backend unless
// VITE_USE_MOCKS is on. All calls are authenticated (the caller's JWT carries the identity).
import { apiClient } from "@/lib/apiClient";
import { env } from "@/lib/env";
import { mockDevicesApi } from "@/mocks/mockDevices";
import type { Device } from "./types";

export interface DevicesApi {
  /** `deviceToken` marks the current browser's row (`current: true`). */
  list(deviceToken: string): Promise<Device[]>;
  rename(id: number, name: string): Promise<void>;
  revoke(id: number): Promise<void>;
}

const realDevicesApi: DevicesApi = {
  async list(deviceToken) {
    // The raw device secret goes in a header, never the URL — query strings leak into
    // access/proxy logs and browser history. The backend reads X-Device-Token.
    const r = await apiClient.get<{ ok: true; devices: Device[] }>(`/auth/devices`, {
      headers: { "X-Device-Token": deviceToken },
    });
    return r.devices;
  },
  async rename(id, name) {
    await apiClient.post(`/auth/devices/${id}/rename`, { name });
  },
  async revoke(id) {
    await apiClient.post(`/auth/devices/${id}/revoke`);
  },
};

export const devicesApi: DevicesApi = env.useMocks ? mockDevicesApi : realDevicesApi;
